import React, { useEffect, useMemo, useState } from "react";
import { IconSortyBy } from "../../../assets/icons/icon-sortby-arrow";

const Dropdown = ({ title, selectedOptions = [], handleChange, options = [] }) => {
  const [showOption, setShowOption] = useState(false);
  const [search, setSearch] = useState("");

  const filteredColumns = useMemo(() => {
    return options.filter(
      (col) =>
        typeof col?.name === "string" &&
        col.name.toLowerCase().includes(search.toLowerCase())
    );
  }, [options, search]);

  const allSelected = options.length > 0 && selectedOptions.length === options.length;
  const selectedName = options.filter(x => selectedOptions.includes(x.value));
  //const someSelected = selectedOptions.length > 0 && !allSelected;

  // Toggle individual selection
  const handleSelect = (value) => {
    const updatedSelection = selectedOptions.includes(value)
      ? selectedOptions.filter((item) => item !== value)
      : [...selectedOptions, value];
    handleChange(updatedSelection);
  };

  // Handle Select All / Deselect All
  const handleSelectAll = () => {
    const newSelection = allSelected ? [] : options.map((opt) => opt.value);
    handleChange(newSelection);
  };

  return (
    <div className="mb-4">
      {/* Dropdown Header */}
      <div
        className={`border p-2 border-[#C8D6E6] ${showOption ? "rounded-t-md" : "rounded-md"
          }`}
        onClick={() => setShowOption(!showOption)}
      >
        <div className="flex pl-2 justify-between items-center cursor-pointer">
          {/* <span className="font-medium">
            {selectedOptions && selectedOptions.length > 0
              ? `${selectedOptions.length} selected`
              : `${title}`}
          </span> */}
          {selectedName.length > 0 ? (<>
            <div className="flex items-center flex-1 flex-wrap relative overflow-hidden box-border">
              {selectedName.map((val) => (<>
                <div className="flex min-w-0 bg-neutral-200 rounded m-0.5 box-border flex items-center">
                  <div className="overflow-hidden text-ellipsis whitespace-nowrap rounded text-neutral-800 text-base pl-1.5 p-0 box-border">{val.name}</div>
                  <button role="button"
                    onClick={(e) => {
                      e.stopPropagation(); // prevent parent onClick
                      handleSelect(val.value);
                    }}
                    className="flex items-center rounded px-1 box-border" aria-label="Remove Prachi Rami">
                    <svg height="14" width="14" viewBox="0 0 20 20" aria-hidden="true" focusable="false" class="css-tj5bde-Svg"><path d="M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"></path></svg>
                  </button></div>
              </>))}
            </div>
          </>) : (<>
            <span className="font-medium">
              {title}
            </span>
          </>)}
          <IconSortyBy />
        </div>
      </div>

      {/* Dropdown Options */}
      {showOption && (
        <div className="flex flex-wrap gap-2 lg:flex-col space-y-2 pl-2 border-t-0 rounded-b-lg border p-2 border-[#C8D6E6]">
          {/* Search Input */}

          {options.length > 0 ? (<>
            <div className="flex relative mt-2">
              <svg className="absolute  top-[10px] left-[10px]" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11.1792 10.3608C10.984 10.1655 10.6674 10.1655 10.4721 10.3608C10.2769 10.556 10.2769 10.8726 10.4721 11.0679L11.1792 10.3608ZM12.7578 13.3536C12.953 13.5488 13.2696 13.5488 13.4649 13.3536C13.6601 13.1583 13.6601 12.8417 13.4649 12.6464L12.7578 13.3536ZM5.31401 3.2433C5.58675 3.2001 5.77283 2.94398 5.72963 2.67124C5.68644 2.3985 5.43031 2.21241 5.15757 2.25561L5.31401 3.2433ZM2.36693 5.04625C2.32373 5.31899 2.50981 5.57511 2.78256 5.61831C3.0553 5.66151 3.31142 5.47542 3.35462 5.20268L2.36693 5.04625ZM10.4721 11.0679L12.7578 13.3536L13.4649 12.6464L11.1792 10.3608L10.4721 11.0679ZM6.2542 10.7857C3.69001 10.7857 1.61133 8.70702 1.61133 6.14285H0.611328C0.611328 9.25931 3.13773 11.7857 6.2542 11.7857V10.7857ZM10.8971 6.14285C10.8971 8.70702 8.81838 10.7857 6.2542 10.7857V11.7857C9.37066 11.7857 11.8971 9.25931 11.8971 6.14285H10.8971ZM6.2542 1.5C8.81838 1.5 10.8971 3.57868 10.8971 6.14285H11.8971C11.8971 3.02639 9.37066 0.5 6.2542 0.5V1.5ZM6.2542 0.5C3.13773 0.5 0.611328 3.02639 0.611328 6.14285H1.61133C1.61133 3.57868 3.69001 1.5 6.2542 1.5V0.5ZM5.15757 2.25561C3.72107 2.48313 2.59445 3.60975 2.36693 5.04625L3.35462 5.20268C3.51436 4.19408 4.3054 3.40305 5.31401 3.2433L5.15757 2.25561Z" fill="#1B2A3D" />
              </svg>
              <input
                type="text"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                className="border-[#C8D6E6] border text-sm rounded-md block w-full h-8 p-1 pl-[30px]"
              />
            </div>

            <hr className="" />

            {/* Select All Checkbox */}
            <label className="flex items-center space-x-2">
              <input
                type="checkbox"
                checked={allSelected}
                onChange={handleSelectAll}
                className="h-4 w-4"
              />
              <span className="text-sm font-medium">
                {allSelected ? "Deselect All" : "Select All"}
              </span>
            </label>

          </>) : (<>
            <span className="text-center">No Options</span>
          </>)}

          {/* Individual Checkboxes */}
          {filteredColumns.map((col) => (
            <label key={col.value} className="flex items-center space-x-2">
              <input
                type="checkbox"
                checked={selectedOptions.includes(col.value)}
                onChange={() => handleSelect(col.value)}
                className="h-4 w-4"
              />
              <span className="text-sm">{col.name}</span>
            </label>
          ))}
        </div>
      )}
    </div>
  );
};

export default Dropdown;
